import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api';
import { queryKeys } from '@/libs/queryKeys';
import { useAuth } from './useAuth';

/** React Query for the current user's published echoes. Disabled when not signed in. */
export const useMyEchoesQuery = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: queryKeys.echoes.mine,
    queryFn: api.echoes.listMyEchoes,
    enabled: isAuthenticated,
  });
};
